export default {
  // Navigation
  nav_home: '홈',
  nav_dashboard: '대시보드',
  nav_orders: '주문',
  nav_wallet: '지갑',
  nav_analytics: '분석',
  nav_referral: '추천',
  nav_account: '계정',
  nav_notifications: '알림',
  nav_support: '지원',
  nav_logout: '로그아웃',
  nav_login: '로그인',
  nav_signup: '가입',

  // Dashboard
  dashboard_welcome: '환영합니다',
  dashboard_total_earnings: '총 수익',
  dashboard_pending_orders: '대기 중인 주문',
  dashboard_completed_orders: '완료된 주문',
  dashboard_commission_rate: '수수료율',
  dashboard_quick_actions: '빠른 작업',
  dashboard_recent_orders: '최근 주문',
  dashboard_recent_activity: '최근 활동',
  dashboard_wallet_balance: '지갑 잔액',
  dashboard_deposit: '입금',
  dashboard_withdraw: '출금',
  dashboard_view_all: '모두 보기',

  // Orders
  orders_title: '내 주문',
  orders_all: '모든 주문',
  orders_pending: '대기 중',
  orders_completed: '완료',
  orders_cancelled: '취소됨',
  orders_order_id: '주문 ID',
  orders_platform: '플랫폼',
  orders_amount: '금액',
  orders_commission: '수수료',
  orders_status: '상태',
  orders_date: '날짜',
  orders_no_orders: '주문을 찾을 수 없습니다',

  // Wallet
  wallet_title: '내 지갑',
  wallet_available_balance: '사용 가능한 잔액',
  wallet_pending_balance: '대기 중인 잔액',
  wallet_total_withdrawn: '총 출금액',
  wallet_deposit_now: '지금 입금',
  wallet_withdraw_now: '지금 출금',
  wallet_transaction_history: '거래 내역',
  wallet_deposit_history: '입금 내역',
  wallet_withdrawal_history: '출금 내역',
  wallet_deposit_desc: "사용 가능한 결제 방법으로 지갑에 돈을 추가하세요.",
  wallet_no_deposits: "입금 내역이 없습니다.",
  wallet_withdraw_history: "출금 내역",
  wallet_withdraw_desc: "지갑에서 돈을 출금하세요.",
  wallet_no_withdrawals: "출금 내역이 없습니다.",

  // Analytics
  analytics_title: '분석',
  analytics_earnings_overview: '수익 개요',
  analytics_platform_breakdown: '플랫폼별 분석',
  analytics_performance_metrics: '성과 지표',
  analytics_top_products: '인기 제품',
  analytics_this_month: '이번 달',
  analytics_last_month: '지난 달',
  analytics_total_revenue: '총 수익',
  analytics_avg_order_value: '평균 주문 금액',

  // Referral
  referral_title: '추천 프로그램',
  referral_your_code: '내 추천 코드',
  referral_copy_code: '코드 복사',
  referral_share_link: '링크 공유',
  referral_total_referrals: '총 추천 수',
  referral_active_referrals: '활성 추천',
  referral_referral_earnings: '추천 수익',
  referral_invite_friends: '친구 초대',

  // Account
  account_title: '계정 설정',
  account_profile: '프로필',
  account_security: '보안',
  account_notifications: '알림',
  account_kyc: 'KYC 인증',
  account_phone: '전화번호',
  account_two_factor: '2단계 인증',
  account_save_changes: '변경사항 저장',
  account_cancel: '취소',

  // Support
  support_title: '지원 센터',
  support_faq: '자주 묻는 질문',
  support_contact_us: '문의하기',
  support_live_chat: '실시간 채팅',
  support_ticket_tracker: '티켓 추적',
  support_submit_ticket: '티켓 제출',

  // Auth
  auth_email: '이메일',
  auth_password: '비밀번호',
  auth_confirm_password: '비밀번호 확인',
  auth_forgot_password: '비밀번호를 잊으셨나요?',
  auth_remember_me: '로그인 상태 유지',
  auth_login_button: '로그인',
  auth_signup_button: '가입',
  auth_already_have_account: '이미 계정이 있으신가요?',
  auth_dont_have_account: '계정이 없으신가요?',
  auth_reset_password: '비밀번호 재설정',
  auth_verify_email: '이메일 확인',

  // Common
  common_loading: '로딩 중...',
  common_save: '저장',
  common_cancel: '취소',
  common_delete: '삭제',
  common_edit: '편집',
  common_view: '보기',
  common_search: '검색',
  common_filter: '필터',
  common_export: '내보내기',
  common_import: '가져오기',
  common_submit: '제출',
  common_close: '닫기',
  common_confirm: '확인',
  common_success: '성공',
  common_error: '오류',
  common_warning: '경고',

  // Homepage
  home_hero_title: '최고의 전자상거래 플랫폼에서 수수료 획득',
  home_hero_subtitle: 'Walmart, Alibaba, AliExpress에서 매일 수수료를 받는 수천 명의 사용자와 함께하세요',
  home_get_started: '지금 시작하기',
  home_learn_more: '자세히 알아보기',
  home_how_it_works: '작동 방식',
  home_features: '기능',
  home_commission_tiers: '수수료 등급',
  home_testimonials: '사용자 후기',
  home_faq: '자주 묻는 질문',
  home_cta_title: '수익을 시작할 준비가 되셨나요?',
  home_cta_subtitle: '오늘 커뮤니티에 가입하고 수수료를 받기 시작하세요',

  // Feature Section
  feature_1_title: '즉시 결제',
  feature_1_desc: '주문 완료 후 즉시 수익이 반영됩니다. 지연 없이 언제든지 출금할 수 있습니다.',
  feature_1_detail_1: '실시간 수수료 크레딧',
  feature_1_detail_2: '다양한 출금 옵션',
  feature_1_detail_3: '최소 한도 없음',
  feature_2_title: '안전한 플랫폼',
  feature_2_desc: '은행 수준의 암호화로 데이터와 수익을 보호합니다. 전 세계 수천 명의 사용자가 신뢰합니다.',
  feature_2_detail_1: 'SSL 암호화 활성화',
  feature_2_detail_2: '2단계 인증',
  feature_2_detail_3: '정기 보안 감사',
  feature_2_detail_4: '데이터 프라이버시 보장',
  feature_3_title: '유연한 시간',
  feature_3_desc: '원할 때 어디서나 일하세요. 고정된 일정 없이 본인의 속도에 맞춰 주문을 완료하세요.',
  feature_3_detail_1: '고정 근무 시간 없음',
  feature_3_detail_2: '어디서나 근무 가능',
  feature_3_detail_3: '본인의 속도 선택',
  feature_3_detail_4: '주말 이용 가능',
  feature_4_title: '점진적 수익',
  feature_4_desc: '더 많은 주문을 완료할수록 더 높은 수수료율을 잠금 해제하세요. 각 등급 업그레이드와 함께 수입을 늘리세요.',
  feature_4_detail_1: '등급별 수수료율',
  feature_4_detail_2: '자동 등급 업그레이드',
  feature_4_detail_3: '성과 보상',
  feature_5_title: '글로벌 플랫폼',
  feature_5_desc: '전 세계 어디서나 국제 브랜드와 협력하세요. 다중 통화 지원이 포함됩니다.',
  feature_5_detail_1: '전 세계 이용 가능',
  feature_5_detail_2: '다중 통화 지원',
  feature_5_detail_3: '로컬 결제 수단',
  feature_6_title: '24/7 지원',
  feature_6_desc: '전담 지원 팀이 항상 도와드릴 준비가 되어 있습니다. 실시간 채팅, 이메일 또는 전화를 통해 지원을 받으세요.',
  feature_6_detail_1: '실시간 채팅 가능',
  feature_6_detail_2: '24/7 이메일 지원',
  feature_6_detail_3: '전화 지원',
  feature_6_detail_4: '종합 FAQ',
  feature_7_title: '추천 프로그램',
  feature_7_desc: '친구를 초대하여 추가 수입을 올리세요. 추천인의 수익에서 평생 수수료를 받으세요.',
  feature_7_detail_1: '평생 추천 수익',
  feature_7_detail_2: '무제한 추천',
  feature_7_detail_3: '쉬운 공유 도구',
  feature_7_detail_4: '보너스 인센티브',
  feature_8_title: '다중 통화 지원',
  feature_8_desc: '주요 통화 및 결제 수단을 지원합니다. 본인에게 가장 적합한 것을 선택하세요.',
  feature_8_detail_1: 'USD, EUR, GBP 지원',
  feature_8_detail_2: '은행 송금 가능',
  feature_8_detail_3: '전자 지갑 통합',
  feature_8_detail_4: '암호화폐 옵션 출시 예정',
  feature_9_title: '즉시 알림',
  feature_9_desc: '새로운 주문, 수익 및 계정 활동에 대한 실시간 알림으로 최신 정보를 확인하세요.',
  feature_9_detail_1: '푸시 알림',
  feature_9_detail_2: '이메일 알림',
  feature_9_detail_3: 'SMS 업데이트',
  feature_9_detail_4: '앱 내 메시지',

  // Footer
  footer_about: '회사 소개',
  footer_terms: '서비스 약관',
  footer_privacy: '개인정보 보호정책',
  footer_contact: '연락처',
  footer_copyright: '모든 권리 보유',

  // Redesigned Footer
  footer_stay_loop_title: '최신 정보 받기',
  footer_stay_loop_desc: '최신 업데이트, 팁 및 독점 혜택을 받은 편지함으로 직접 받으세요.',
  footer_subscribe: '구독하기',
  footer_subscribe_placeholder: '이메일 주소를 입력하세요',
  footer_trusted_secure: '신뢰 및 보안:',
  footer_ssl_secured: 'SSL 보안',
  footer_ssl_secured_desc: '256비트 SSL',
  footer_aes_encryption: 'AES-256 암호화',
  footer_aes_encryption_desc: '은행 수준',
  footer_kyc_compliant: 'KYC 준수',
  footer_kyc_compliant_desc: '확인됨',
  footer_gdpr_compliant: 'GDPR 준수',
  footer_gdpr_compliant_desc: '데이터 보호됨',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: '인증됨',
  footer_platform: '플랫폼',
  footer_support: '지원',
  footer_legal: '법적 정보',
  footer_help_center: '고객 센터',
  footer_contact_us: '문의하기',
  footer_payments_label: '결제 방법:',
  home_live_activity_title: '라이브 플랫폼 활동',
  home_recent_activity_title: '최근 활동',
  home_total_commissions_paid: '총 지급 수수료',
  home_active_users_online: '온라인 활성 사용자',
  home_tasks_completed_today: '오늘 완료된 작업',
};